module.exports = __webpack_public_path__ + "static/img/defaultbg.dcd284bd.png";